import api from './api';

export async function getBranches() {
  const { data } = await api.get('/branch');
  return data;
}

export async function createBranch(payload) {
  const { data } = await api.post('/branch', payload);
  return data;
}

export async function updateBranch(id, payload) {
  const { data } = await api.put(`/branch/${id}`, payload);
  return data;
}

export async function changeBranchState(id) {
  const { data } = await api.get(`/branch/change-state/${id}`);
  return data;
}

export async function deleteBranch(id) {
  const { data } = await api.delete(`/branch/${id}`);
  return data;
}
